import React from 'react';
import PropTypes from 'prop-types';
import { colors } from '../../../css';

function Pipeline(props) {
  const { height, width, backgroundColor, iconColor } = props;

  return (
    <svg width={width} height={height} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 120">
      <rect fill={backgroundColor} opacity={0.4} x="14.76" y="51.12" width="28.99" height="8" />
      <rect fill={backgroundColor} opacity={0.4} x="76.26" y="51.12" width="28.99" height="8" />
      <rect
        fill="none"
        stroke={iconColor}
        strokeMiterlimit={10}
        strokeWidth="2.33px"
        x="43.74"
        y="35.47"
        width="32.51"
        height="48.2"
      />
      <line
        fill="none"
        stroke={iconColor}
        strokeMiterlimit={10}
        strokeWidth="2.33px"
        x1="105.24"
        y1="45.52"
        x2="76.26"
        y2="45.52"
      />
      <line
        fill="none"
        stroke={iconColor}
        strokeMiterlimit={10}
        strokeWidth="2.33px"
        x1="105.24"
        y1="74.52"
        x2="76.26"
        y2="74.52"
      />
      <line
        fill="none"
        stroke={iconColor}
        strokeMiterlimit={10}
        strokeWidth="2.33px"
        x1="43.74"
        y1="45.52"
        x2="14.76"
        y2="45.52"
      />
      <line
        fill="none"
        stroke={iconColor}
        strokeMiterlimit={10}
        strokeWidth="2.33px"
        x1="43.74"
        y1="74.52"
        x2="14.76"
        y2="74.52"
      />
      <path fill="none" stroke={iconColor} strokeMiterlimit={10} strokeWidth="2.33px" d="M60,59.57v0Z" />
      <path
        d="M70.67,25.5 L22,25.5"
        fill="none"
        stroke={iconColor}
        strokeMiterlimit={10}
        strokeWidth="2.33px"
        transform="translate(85.400000, 13.500000) rotate(-270.000000) "
      />
    </svg>
  );
}

Pipeline.propTypes = {
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  backgroundColor: PropTypes.string,
  iconColor: PropTypes.string
};

Pipeline.defaultProps = {
  height: undefined,
  width: 120,
  iconColor: colors.colorGrey02,
  backgroundColor: colors.iconGreen
};

export default Pipeline;
